<template>
  <el-dialog
    title="排除"
    :visible.sync="viewVisible"
    :close-on-click-modal="false"
    @close="close"
    width="600px"
  >
    <el-form
      :model="excludeForm"
      :label-width="'95px'"
      status-icon
      :disabled="isReadOnly"
      :rules="rules"
      ref="ruleForm"
    >
      <el-form-item label="节点名称" prop="name" >
        <el-input
          show-word-limit
          maxlength="20"
          v-model="excludeForm.name"
          style="width:80%"
        ></el-input>
      </el-form-item>

      <el-form-item label="源数据人群" prop="sourceNodeId">
        <div class="selectBox">
          <el-select
            v-model="excludeForm.sourceNodeId"
            placeholder="请选择"
            style="width:80%"
            :disabled="dataForm"
          >
            <el-option
              v-for="item in options"
              :key="item.nodeId"
              :label="item.nodeName"
              :value="item.nodeId"
            >
            </el-option>
          </el-select>
        </div>
      </el-form-item>
      <el-form-item label="排除人群" prop="excludeNodeId">
        <div class="selectBox">
          <el-select
            v-model="excludeForm.excludeNodeId"
            placeholder="请选择"
            style="width:80%"
            :disabled="dataForm"
          >
            <el-option
              v-for="item in options"
              :key="item.nodeId"
              :label="item.nodeName"
              :value="item.nodeId"
            >
            </el-option>
          </el-select>
        </div>
        <el-button
          class="switchover"
          @click="switchover"
          icon="el-icon-sort"
          style="width:40px"
          size="mini"
        ></el-button>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="viewVisible = false">取 消</el-button>
      <el-button type="primary" v-loading="loading" :disabled="isReadOnly" @click="excludeSubmit"
        >确 定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import mnode from "@/api/intelligentMarket/a_node";
export default {
  name: "excludeDialog",
  data() {
    let validatesid = (rule, value, callback) => {
      if (this.excludeForm.excludeNodeId !== "") {
        this.$refs.ruleForm.validateField("excludeNodeId");
      }
      callback();
    };
    let validateeid = (rule, value, callback) => {
      if (value === this.excludeForm.sourceNodeId) {
        callback(new Error("源数据人群和排除人群不能是同一个节点!"));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      rules: {
        name: [
          { required: true, message: "请输入节点名称", trigger: "blur" },
          {
            min: 1,
            max: 20,
            message: "长度在 1 到 20 个字符",
            trigger: "blur",
          },
        ],
        sourceNodeId: [
          { required: true, message: "请选择源数据人群", trigger: "change" },
          { validator: validatesid, trigger: "change" },
        ],
        excludeNodeId: [
          { required: true, message: "请选择排除人群", trigger: "change" },
          { validator: validateeid, trigger: "change" },
        ],
      },
      excludeForm: {
        name: "",
        sourceNodeId: "",
        excludeNodeId: "",
      },
      options: [],
      nodeName: "",
      dataForm:true
    };
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    nodeId: Number,
    marketingId: Number,
    isReadOnly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    viewVisible: {
      get: function() {
        return this.visible;
      },
      set: function(newValue) {
        if (newValue) {
          this.$emit("update:visible", true);
        } else {
          this.$emit("update:visible", false);
        }
      },
    },
    getNameLength: function() {
      return this.excludeForm.name.length;
    },
  },
  components: {},
  created() {
     mnode.getNode({nodeId: this.nodeId}).then(res => {
      if (res.code === 1 && res.data.name) {
        let formData
        if (res.data && res.data.excludeNode && res.data.excludeNode.dataList && res.data.excludeNode.dataList.length > 1) {
          formData = res.data.excludeNode
          this.excludeForm.name = res.data.name
          if(formData.dataList.length!==[]){
             this.dataForm=false;
          }
          if (formData && formData.sourceNodeId) {
            this.excludeForm.sourceNodeId = formData.sourceNodeId
          }
          if (formData && formData.excludeNodeId) {
            this.excludeForm.excludeNodeId = formData.excludeNodeId
          }
          this.options = formData &&  formData.dataList || []
        }
      }
    })
  },
  methods: {
    excludeSubmit() {
      if (this.loading) {
        return;
      }
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let data = this.getDataify();
          if (data) {
            this.loading = true;
            mnode.updateDetailexclude(data).then(res => {
              this.loading = false;
              if (res.code === 1) {
                this.$message.success(res.message)
                this.viewVisible = false
                this.$emit('change-name', data)
              }
            })
          }
        } else {
          return false;
        }
      });
    },
    getDataify() {
      let formData = {};
      let data = this.excludeForm;
      formData.nodeId = this.$props.nodeId;
      formData.name = this.excludeForm.name;
      formData.sourceNodeId = this.$data.excludeForm.sourceNodeId;
      formData.excludeNodeId = this.$data.excludeForm.excludeNodeId; 
      // formData.excludeNode = JSON.parse(
      //   JSON.stringify(data, (k, v) => {
      //     return k === "name" ? undefined : v;
      //   })
      // );
      return formData;
    },
    switchover() {
      let val = this.$data.excludeForm.sourceNodeId;
      this.$data.excludeForm.sourceNodeId = this.$data.excludeForm.excludeNodeId;
      this.$data.excludeForm.excludeNodeId = val;
    },
    close() {
      this.viewVisible = false;
    },
  },
};
</script>

<style scoped lang="scss">
.selectBox {
  width: 100%;
  display: flex;
  position: relative;
}
</style>
